import React, {useState, useEffect} from 'react';
import styled from '@emotion/styled';

const TableRow = styled.div`
  display: grid;
  grid-auto-flow: column;
  
  grid-template-columns: ${props => props.spacing ? props.spacing : 'auto'};
  
  align-items: center;
  
  padding: 1rem 1.5rem 1rem 1.5rem;
  
  background: ${props => props.selected ? 'var(--color-gray-100)' : ''};
  border: ${props => props.selected ? '2px solid #02B2D9' : ''};
  box-sizing: ${props => props.selected ? 'border-box' : ''};
  
  &:hover {
    background: var(--color-gray-100);
    transition: background-color 0.3s ease-in;
  }
`;

const InnerTableContent = styled.div`
  overflow-y: scroll;
  height: calc(100% - 10rem);
`;

const ColumnHeader = styled.h3`
  display: flex;
  flex-direction: row;
  align-items: center;
  
  cursor: pointer;
  
  justify-content: ${props => props.center ? 'center' : ''};
  
  > span {
    height: 0.75rem;
  
    
    font-style: normal;
    font-weight: 500;
    font-size: 0.75rem;
    line-height: 0.75rem;
    color: var(--color-gray-500);
  }
  
  > img {
    margin: 0 0 0 0.25rem;
  }
`;

const TableFooter = styled.div`
  width: 100%;
  height: 4rem;
  
  background: white;
  
  position: absolute;
  bottom: 0;
  
  padding: 0 1.5rem 0 1.5rem;
`;

const Pagination = styled.div`
  display: flex;
  align-items: center;
  
  height: 100%;
  
  > img {
    cursor: pointer;
  
    &:first-child {
      margin: 0 0.75rem 0 0;
    }
  
    &:last-child {
      margin: 0 0 0 0.75rem;
    }
  }
  
  > span {
    background: var(--color-gray-100);
    
    padding: 0.375rem 0.75rem;
    border-radius: 0.375rem;
    
    
    font-size: 1rem;
    line-height: 1rem;
    font-weight: 500;
  }
`;

function DataTable({headers, rows, changeSort, spacing, currentPage, pageCount, pageBack, pageNext, highlight = false}) {
    const [selectedIndex, setSelectedIndex] = useState(-1);
    const [selectedSortIndex, setSelectedSortIndex] = useState(-1);
    const [sortOrder, setSortOrder] = useState(-1); // sort order is 1 (asc) and -1 (des) as determined by MongoDB

    const processSort = index => {
        if (selectedSortIndex === -1) return '/icons/sort.svg';

        if (selectedSortIndex === index) {
            if (sortOrder > 0) return '/icons/sorted-down.svg';
            else if (sortOrder < 0) return '/icons/sorted-up.svg';
        } else return '/icons/sort.svg';
    };

    return (
        <>
            <TableRow spacing={spacing} style={{marginRight: '5px'}}>
                {
                    headers.map((header, index) => {
                        return <ColumnHeader onClick={() => {
                            if (header.sortable && header.sort) {
                                changeSort({[header.sort]: sortOrder});
                                setSortOrder(sortOrder * -1);
                                setSelectedSortIndex(index);
                            }
                        }} key={`DataTableColumnHeader_${index}`} center={header.center}>
                            <span>{header.title}</span>
                            {(header.sortable && header.sort) && <img src={processSort(index)} alt="sort"/>}
                        </ColumnHeader>;
                    })
                }
            </TableRow>

            <InnerTableContent>
                {
                    rows.map((row, index) => {
                        return <TableRow
                            key={`DataCellTableRow_${index}`}
                            selected={selectedIndex === index || row.data?._id === highlight}
                            spacing={spacing}
                            style={{
                                cursor: 'pointer',
                                background: index % 2 === 0 ? 'var(--color-gray-100)' : '#ffffff'
                            }}
                            onClick={() => {
                                setSelectedIndex(index);
                                row.onRowSelect(row.data);
                            }}>
                            {row.view}
                        </TableRow>;
                    })
                }
            </InnerTableContent>
            <TableFooter>
                <Pagination>
                    <img src="/icons/chevron_left.svg" alt="page_left" onClick={pageBack}/>
                    <span>{currentPage} of {pageCount || 1}</span>
                    <img src="/icons/chevron_right.svg" alt="page_right" onClick={pageNext}/>
                </Pagination>
            </TableFooter>
        </>
    );
}

export default DataTable;
